import { inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { firstValueFrom } from 'rxjs';

export const translationResolver = () => {
  const translateService = inject(TranslateService);

  return firstValueFrom(translateService.get('global.currency_sign'));
};

